import Loader from 'components/Loader/Loader'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom'
import { RobotActions } from 'store/actions/robot'
import { selectRobot } from 'store/selectors/robot'
import { selectRobotLoadingProgress } from 'store/selectors/robot'
import type { AppDispatch } from 'store/store'
import { robotThunks } from 'store/thunks/robot'
import { GAUSIUM_ENABLED, PATH, PROGRESS_TYPES } from 'utils/constants'
import { isRobotNotFoundError } from 'utils/robotFetchErrors'
import { VENDOR } from 'utils/vendorDisplayName'

import RobotView from './RobotView/RobotView'

import style from './Robot.module.css'
import pageLayoutStyle from 'styles/pageLayout.module.css'

const Robot = () => {
  const loadingProgress = useSelector(selectRobotLoadingProgress)
  const params = useParams()
  const robotId = parseFloat(params.id || '')
  const dispatch = useDispatch<AppDispatch>()
  const navigate = useNavigate()
  const robot = useSelector(selectRobot)

  useEffect(() => {
    if (!Number.isFinite(robotId) || robotId < 1) {
      navigate(PATH.ASSET_LIST, { replace: true })
      return
    }
    let cancelled = false
    ;(async () => {
      try {
        await dispatch(robotThunks.fetchRobot(robotId))
      } catch (e) {
        if (cancelled) return
        if (isRobotNotFoundError(e)) {
          navigate(PATH.ASSET_LIST, { replace: true })
        }
      }
    })()
    return () => {
      cancelled = true
      dispatch(RobotActions.resetRobot())
    }
  }, [robotId, navigate, dispatch])

  useEffect(() => {
    if (!GAUSIUM_ENABLED && robot.robotInfo?.vendor === VENDOR.GAUSIUM) {
      navigate(PATH.ASSET_LIST, { replace: true })
    }
  }, [robot.robotInfo?.vendor, navigate])

  const stateList = {
    [`${PROGRESS_TYPES.SUCCESS}`]: <RobotView />,
    [`${PROGRESS_TYPES.WORK}`]: <Loader />,
    [`${PROGRESS_TYPES.ERROR}`]: <span>Error</span>,
  }

  return <div className={style.container}>{stateList[loadingProgress]}</div>
}

export default Robot
